export default __webpack_public_path__ + "static/media/jquery-icon.739e5fda.svg";